import {defineStore} from 'pinia'

const name = 'appEnv'

export const useAppEnvStore = defineStore(name,{

  id: name,

  state: () => ({
      env: {},
      current: 0,
    }
  ),

  actions: {

    load(payload) {
      this.env = payload;
    },

  },
  getters: {
    getEnv: (state) => (name) => {
      return window?.environment?.[name] || state.env[name];
    },
  }

})
